import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { Box } from '@allied-solutions/affinity'
import {
  useGetCoverageRequirements,
  useInsuranceDocumentQuery,
} from '../../hooks'
import { DashboardSkeletonTile } from './DashboardSkeletonTile'
import { DashboardErrorCard } from './DashboardErrorCard'
import { DashboardTile } from './DashboardTile'
import { DashboardUploadInsuranceModal } from './DashboardUploadInsuranceModal'

export const DashboardRefTile = ({
  refId,
  agencyId,
  marginTop,
  isExpanded,
  onOpenHelp,
  setShowSuccessMessage,
}) => {
  const [isOpen, setIsOpen] = useState(false)
  const [selectedUploadReferenceId, setSelectedUploadReferenceId] = useState(
    null
  )
  const {
    data: coverageRequirementsData,
    isLoading: isLoadingCoverageRequirements,
    error: coverageRequirementsError,
    isError: isCoverageRequirementsError,
  } = useGetCoverageRequirements(refId, agencyId)

  const {
    data: borrowerData,
    isLoading: isLoadingBorrower,
    isError: isBorrowerError,
  } = useInsuranceDocumentQuery(refId, agencyId)

  useEffect(() => {
    const firstReferenceId = coverageRequirementsData?.[0]?.ReferenceID
    if (firstReferenceId != null && selectedUploadReferenceId == null) {
      setSelectedUploadReferenceId(String(firstReferenceId))
    }
  }, [coverageRequirementsData, selectedUploadReferenceId])

  const openUploadModal = referenceId => {
    if (referenceId != null && referenceId !== '') {
      setSelectedUploadReferenceId(String(referenceId))
    }
    setIsOpen(true)
  }

  if (isLoadingBorrower || isLoadingCoverageRequirements) {
    return (
      <DashboardSkeletonTile marginTop={marginTop} isExpanded={isExpanded} />
    )
  }

  if (isBorrowerError || isCoverageRequirementsError) {
    return (
      <Box mt={marginTop}>
        <DashboardErrorCard />
      </Box>
    )
  }

  return (
    <Box mt={marginTop}>
      <DashboardTile
        borrowerData={borrowerData}
        refId={refId}
        openUploadModal={openUploadModal}
        onActiveCoverageReferenceIdChange={setSelectedUploadReferenceId}
        onOpenHelp={onOpenHelp}
        isExpanded={isExpanded}
        coverageRequirementsData={coverageRequirementsData}
        isLoadingCoverageRequirements={isLoadingCoverageRequirements}
        coverageRequirementsError={coverageRequirementsError}
        isCoverageRequirementsError={isCoverageRequirementsError}
      />
      <DashboardUploadInsuranceModal
        borrowerData={borrowerData}
        coverageRequirementsData={coverageRequirementsData}
        selectedReferenceId={selectedUploadReferenceId}
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        setShowSuccessMessage={setShowSuccessMessage}
      />
    </Box>
  )
}

DashboardRefTile.propTypes = {
  refId: PropTypes.string.isRequired,
  agencyId: PropTypes.number.isRequired,
  marginTop: PropTypes.string.isRequired,
  isExpanded: PropTypes.bool.isRequired,
  onOpenHelp: PropTypes.func.isRequired,
  setShowSuccessMessage: PropTypes.func.isRequired,
}
